// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import PrivateRoute from '@Molecules/PrivateRoute/PrivateRoute';
import { Switch } from 'react-router-dom';
import UnknownRoute from '@Molecules/UnknownRoute/UnknownRoute';
import { ADMIN_ORG_ID, RouteType } from '@Types';
import { useCurrentUser } from '@Queries/userQueries';
import RouteBuilder from '@Services/RouteBuilder';

type RoutingProps = { routes: RouteType[] };

const Routing = ({ routes }: RoutingProps): ReactElement => {
    const { data: currentUser } = useCurrentUser();
    const { organisation } = currentUser || {};

    return (
        <Switch>
            {routes && [
                ...routes.map(({ content, shared, Context, space, exact, path }) => {
                    if (organisation === ADMIN_ORG_ID && path === RouteBuilder.compute('administration.links')) {
                        return;
                    }

                    return (
                        <PrivateRoute key={path} path={path} space={space} shared={shared} exact={exact}>
                            {Context ? <Context key={path}>{content}</Context> : content}
                        </PrivateRoute>
                    );
                }),
                <UnknownRoute key="any-route" />,
            ]}
        </Switch>
    );
};

export default Routing;
